






import Vue from 'vue';

export default Vue.extend({
  name: "NewcomersMain2d",
  data: () => {
    return {};
  },
});
